
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function LoginPage() {
  const [identifier, setIdentifier] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const isEmail = identifier.includes('@');
      const query = supabase.from('users').select('*').eq('status', 'active');

      if (isEmail) {
        query.eq('email', identifier);
      } else {
        query.eq('phone_number', identifier); // Fixed: changed from 'phone' to 'phone_number'
      }

      const { data: users, error: fetchError } = await query;

      if (fetchError) {
        console.error('Database query error:', fetchError);
        throw fetchError;
      }

      if (!users || users.length === 0) {
        setError('Invalid credentials');
        setLoading(false);
        return;
      }

      const user = users[0];

      if (user.password_hash !== password) {
        setError('Invalid credentials');
        setLoading(false);
        return;
      }

      await supabase.from('users').update({ last_login: new Date().toISOString() }).eq('id', user.id);

      localStorage.setItem('mkf_user', JSON.stringify(user));
      navigate('/');
    } catch (err) {
      console.error('Login error:', err);
      setError('An error occurred during login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-black to-purple-900 flex items-center justify-center px-4">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <img 
            src="https://static.readdy.ai/image/8fab16e78421d1397ff0fcc9b5c0da42/c2ee5c8cb3071676452775641a0eca7c.png"
            alt="Monkey Knife Fight Logo"
            className="w-80 h-auto mx-auto object-contain"
          />
        </div>

        <div className="bg-gray-900/50 backdrop-blur-sm rounded-2xl shadow-2xl p-8 w-full max-w-md border border-purple-500/30">
          <div className="text-center mb-8">
            <p className="text-gray-400">Welcome back! Please Login Here.</p>
          </div>

          <h2 className="text-2xl font-bold text-white mb-6 text-center">Member Login</h2>
          
          {error && (
            <div className="bg-red-500/20 border border-red-500 text-red-200 px-4 py-3 rounded mb-4">
              {error}
            </div>
          )}

          <form onSubmit={handleLogin} className="space-y-4">
            <div>
              <label className="block text-gray-300 mb-2">Email or Phone Number</label>
              <input
                type="text"
                value={identifier}
                onChange={(e) => setIdentifier(e.target.value)}
                required
                className="w-full px-4 py-3 bg-gray-900 border border-gray-70
0 rounded-lg text-white focus:outline-none focus:border-purple-5"
                placeholder="your@email.com or (555) 123-4567"
              />
            </div>

            <div>
              <label className="block text-gray-300 mb-2">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="w-full px-4 py-3 bg-gray-900 border border-gray-700 rounded-lg text-white focus:outline-none focus:border-purple-5"
                placeholder="••••••••"
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-purple-600 hover:bg-purple-700 text-white font-bold py-3 rounded-lg transition disabled:opacity-50"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>
        </div>

        <div className="text-center">
          <img 
            src="https://static.readdy.ai/image/8fab16e78421d1397ff0fcc9b5c0da42/cce27c2cfd2bf01687e7fa86a5476c15.png" 
            alt="Join us" 
            className="w-64 h-auto mx-auto mb-4 object-contain"
          />
          <button
            onClick={() => navigate('/join')}
            className="bg-gradient-to-r from-purple-600 to-purple-500 hover:from-purple-7
00 hover:to-purple-600 text-white font-bold py-3 px-8 rounded-lg transition shadow-lg"
          >
            Join Monkey Knife Fight
          </button>
        </div>
      </div>
    </div>
  );
}
